import { MeetingServiceOrder } from "../../../../merchant/accounting/accounting/accountingTypes"
import { AxiosInstance } from "axios"
import { DateType } from "../../../../../shared/components/filters/selectDateTypeFilter/SelectDateTypeFilter"

export enum ArchiveMeetingService {
    ARCHIVE_MEETING_SERVICE = "archive-meeting-service-for-user",
}

type FetchUserMeetingServiceParams = Readonly<{
    startDate: string
    endDate: string
    dateType?: DateType
}>

export type FetchUserMeetingServiceResponse = Readonly<{
    orders: MeetingServiceOrder[]
}>

export async function fetchUserMeetingService(
    params: FetchUserMeetingServiceParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchUserMeetingServiceResponse> {
    const url = "/me/archive/meetingService"

    const { data } = await axios.get(url, {
        params,
        signal,
    })

    return data
}
